import { set } from 'lodash-es';
import * as z from 'zod';
import * as ba from './base';

export interface RegisterActionArgs {
  name: string;
  value: string;
}

export class RegisterAction extends ba.Action<RegisterActionArgs, any> {
  static get manifest() {
    return {
      name: 'register',
      schema: z.object({
        name: z.string(),
        value: z.string(),
      }),
    };
  }

  async handle(event: ba.ActionEvent, args: RegisterActionArgs) {
    set(event.data, args.name, args.value);
  }
}
